<template>
  <div class="agent__contacts" role="list" aria-label="Kiinteistönvälittäjät">
    <template v-for="person in persons">
      <person
        v-if="!person.hidden"
        :key="`person-${person.agentId}`"
        :person="person"
        :pictures-exist="picturesExist()"
        :office="office"
        role="listitem"
      />
    </template>
  </div>
</template>
<script setup lang="ts">
import Person from '@/app/components/persons/person.vue';
const { persons } = defineProps<{
  persons: Array<any>;
  office?: any;
}>();

const picturesExist = () => {
  return persons ? Object.values(persons).some((x) => 'pictureUrl' in x) : false;
};
</script>
